import React from "react";
import MDBox from "components/MDBox";
import TableData from "./components/table";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import AddUserDetailsPopup from "./components/AddUserDetailsPopup";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
function UserManagement() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox>
        <TableData/>
        <AddUserDetailsPopup/>
      </MDBox>
    </DashboardLayout>
  );
}

export default UserManagement;
